import React from 'react';
import {
  Heading3,
  Margin,
  SecondaryCTAButton,
  Spinner,
} from '@ovotech/element-v4';
import { useEnergyQuoteEligibility } from '@/src/api/use-energy-quote-eligibility';
import { TuwyEligibility } from '../TuwyEligibility/TuwyEligibility';
import styles from './Eligibility.module.css';
import { MovingDateValues } from '@/src/types/MoveOut';
import { HOME_MOVES_END_CONTRACT } from '@/src/constants/analytics-subjects';
import { AnalyticsClick } from '@ovotech/ui-tools';
type EligibilityProps = {
  postCode: string;
  propertySearchId: string;
  movingDateValues: MovingDateValues;
  onGetQuoteClick: ({ isCot }: { isCot: boolean }) => void;
  onEndContractClick: () => void;
};

export const Eligibility = ({
  postCode,
  propertySearchId,
  movingDateValues,
  onGetQuoteClick,
  onEndContractClick,
}: EligibilityProps) => {
  const energyQuoteEligibilityResult = useEnergyQuoteEligibility(
    {
      postCode,
      propertySearchId,
    },
    {
      keepPreviousData: true,
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      cacheTime: 0,
    },
  );

  const data = energyQuoteEligibilityResult.data
    ? energyQuoteEligibilityResult.data
    : undefined;

  if (energyQuoteEligibilityResult.isFetching) {
    return (
      <div className={styles.loading}>
        <Spinner size="small" />
        <span>Loading...</span>
      </div>
    );
  }

  return (
    <>
      <TuwyEligibility
        data={data}
        movingDateValues={movingDateValues}
        onGetQuoteClick={() =>
          onGetQuoteClick({
            isCot: data?.supplier === 'OVO',
          })
        }
      />

      <Margin top={[6, 6, 6]}>
        <Heading3 className={styles.title}>Want to end your contract?</Heading3>
        <div className={styles.description}>
          We'll end your contract on your moving day and ask you to send your
          final meter reading. We'll also create a final bill and refund any
          money left on your account.
        </div>
      </Margin>

      <Margin top={[5, 6, 6]}>
        <AnalyticsClick name={HOME_MOVES_END_CONTRACT}>
          <SecondaryCTAButton
            type="button"
            onClick={() => {
              onEndContractClick();
            }}
          >
            End my contract
          </SecondaryCTAButton>
        </AnalyticsClick>
      </Margin>
    </>
  );
};
